module.exports = __webpack_public_path__ + "img/securityImg3.8f0779be.png";